import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'
import { toast } from 'react-toastify'
// this is for demo purpose only / change for further api calls

const config = {
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
  method: 'post',
}

export const editBranch = createAsyncThunk('branch/editBranch', async ({ id, editObj, navigate }, { dispatch }) => {
  try {
    const response = await apiClient.put(`/branch/${id}`, editObj, config)
    dispatch(getBranch({}))
    if (response) {
      navigate('/branch')
    }
    if (response.status) {
      toast.success(response.data.message, {
        className: 'custom-toast-success',
        progressStyle: { background: '#ffffff' },
      })
    }
    return response.data
  } catch (error) {
    toast.error(error.response.data.message, {
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    console.error('builder function error:', error)
    throw error
  }
})

export const getBranch = createAsyncThunk('branch/getBranch', async (status) => {
  try {
    let response
    if (status) {
      response = await apiClient.get(`/branches?branchStatus=${status}`)
    } else {
      response = await apiClient.get(`/branches`)
    }
    response?.data?.result?.branches?.forEach(branch => {
  
      branch.fulladdress = `${branch?.addressLine} ${branch?.areaName} ${branch?.cityName} ${branch?.stateName}`
    });   

    return response?.data?.result?.branches // todo: need to store only "result" array inside redux state
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})
export const getBatch = createAsyncThunk('batch/getBatch', async (status) => {
  try {
    let response
    if (status) {
      response = await apiClient.get(`/batches?batchStatus=${status}`)
    } else {
      response = await apiClient.get(`/batches`)
    }
    return response.data // todo: need to store only "result" array inside redux state
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})
export const getClassRoom = createAsyncThunk('branch/getClassroom', async () => {
  try {
    const response = await apiClient.get('/branchClassroom')
    return response.data // todo: need to store only "result" array inside redux state
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})
export const getFaculties = createAsyncThunk('faculty/getFaculties', async (status) => {
  try {
    let response
    if (status) {
      response = await apiClient.get(`/faculties?facultyStatus=${status}`)
    } else {
      response = await apiClient.get(`/faculties`)
    }
    return response.data
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const createBranchClassroom = createAsyncThunk('branch/branchClassroom', async (data) => {
  try {
    const response = await apiClient.post('/branchClassroom', data.classRoomObj)
    if (response.status) {
      toast.success(response.data.message, {
        className: 'custom-toast-success',
        progressStyle: { background: '#ffffff' },
      })

      data.setOpen(false)
    }

  } catch (error) {
    toast.error(error.response.data.message, {
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    console.error('builder function error:', error)
    throw error
  }
})

export const getAllCourse = createAsyncThunk('course/get-all-course', async () => {
  try {
    const response = await apiClient.get('/courses')
    const courses = response?.data?.result?.courses.map((course) => {
      return {
        courseId: course.courseId,
        courseName: course.courseName,
      }
    })
    return courses
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getBranchListData = createAsyncThunk('branch/get-branch-list', async () => {
  try {
    const response = await apiClient.get('/branches')
    const branches = response.data.result.branches.map((branch) => {
      return {
        branchId: branch.branchId,
        branchName: branch.branchName,
      }
    })
    return branches
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})
export const getBatchOptionList = createAsyncThunk('branch/get-batch-list', async (branchId) => {
  try {
    const response = await apiClient.get(`/batchesByBranchId?branchId=${branchId}`)

    return response.data.result.batches
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})


export const createBatch = createAsyncThunk(
  'batch/create-batch',
  async ({ values, dispatch, branchId }) => {
    try {
      const response = await apiClient.post('/batch', {
        branchId : values.branch,
        batchNo: values.batch,
        courseId: values.course,
        batchStartDate: values.startdate,
        batchEndDate:values.enddate,
      })
      if (response.status) {
        dispatch(getBatchOptionList(branchId))
        toast.success(response.data.message, {
          className: 'custom-toast-success',
          progressStyle: { background: '#ffffff' },
        })
      }
    } catch (error) {
      console.error('builder function error:', error)
      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        progressStyle: { background: '#C53C43' },
      })
      throw error
    }
  },
)
export const updateBatch = createAsyncThunk(
  'batch/update-batch',
  async ({ values, dispatch, branchId, batchId }) => {
    try {
      const response = await apiClient.put(`/batch/${batchId}`, {
        branchId : values.branch,
        batchNo: values.batch,
        courseId: values.course,
        batchStartDate: values.startdate,
        batchEndDate:values.enddate,
      })
      if (response.status) {
        dispatch(getBatchOptionList(branchId))
        toast.success(response.data.message, {
          className: 'custom-toast-success',
          progressStyle: { background: '#ffffff' },
        })
      }
    } catch (error) {
      console.error('builder function error:', error)
      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        progressStyle: { background: '#C53C43' },
      })
      throw error
    }
  },
)

export const createBranch = createAsyncThunk('branch/createBranch', async ({ values, navigate }, { dispatch }) => {
  try {
    // const username = values.userFirstName+ " "+ values.userLastName

    const branchData = {
      stateId: values.branchState,
      areaId: values.branchArea,
      cityId: values.branchCity,
      addressLine: values.branchFullAddress,
      branchPhone: values.branchMobileNumber,
      branchEmail: values.branchEmail,
      branchGst: values.gstNo,
      branchCin: values.cinNo,
      feeReceipt: values.receiptNote,
      branchAlias: values.branchAlias,
      branchName: values.branchName,
      userPhone: values.userPhone,
      userEmail: values.userEmail,
      userPassword: values.userPassword,
      userName: values.userFirstName + ' ' + values.userLastName,
    }

    const response = await apiClient.post('/branch', branchData, config)
    dispatch(getBranch({}))
    if (response.status) {
      navigate('/branch')
      toast.success(response.data.message, {
        className: 'custom-toast-success',
        progressStyle: { background: '#ffffff' },
      })
    }
  } catch (error) {
    console.error('builder function error:', error)
    toast.error(error.response.data.message, {
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    throw error
  }
})

export const archiveBranch = createAsyncThunk('branch/archive-branch', async ({ branchId, dispatch, toast }) => {
  try {
    const response = await apiClient.post(`/branch/${branchId}/archive`, {
      branchStatus: 'archive',
    })
    dispatch(getBranch())
    if (response.status) {
      toast.success(response.data.message, {
        className: 'custom-toast-success',
        progressStyle: { background: '#ffffff' },
      })
    }
  } catch (error) {
    console.error('builder function error:', error)
    // TODO: Change api error response message for archive api
    toast.error(error.response.data.message, {
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    throw error
  }
})

export const getSoloBranch = createAsyncThunk('branch', async ({ id }) => {
  try {
    const url = `/branch/${id}`
    const response = await apiClient.get(url)
    return response?.data?.result?.branches[0]
  } catch (error) {
    console.error('builder function error:', error)
    toast.error(error.response.data.message, {
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    throw error
  }
})

// export const listBranch = createAsyncThunk(
//   "branch/listBranch",
//    async ({ fieldName , value }) => {
//     try {
//       const response = await apiClient.get(`/branch?fieldName=${fieldName}&value=${value}`);
//       return response.data
//     } catch (error) {
//       console.error("builder function error:", error);
//       throw error;
//     }
//   }
// );
